// extracted by mini-css-extract-plugin
export default {"product-image":"MyProductReservationDetail_product-image__eyaEx"};